import { ActionTypes } from 'src/store/actions/confirmationsActions';
import { mergeUserConfirmationPeriods } from 'src/store/reducers/tools/confirmations';
const initialState = {
    userConfirmationPeriods: {}
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SAVE_USER_PERIOD_CONFIRMATIONS: {
            return {
                ...state,
                userConfirmationPeriods: mergeUserConfirmationPeriods(state.userConfirmationPeriods, payload.confirmations)
            };
        }
        default: {
            return state;
        }
    }
};
